import { Button, Skeleton, message } from "antd";
import React, { useEffect, useState } from "react";
import CarImg from "../../assets/carww.png";
import { HeartOutlined, HeartFilled } from "@ant-design/icons";
import Api from "../../network/ApiConfig";
export default function CarCard({ setDetailsModal, car, CarSearchLoading }) {
  const [isFav, setisFav] = useState(false);
  const [CarFavLoading, setCarFavLoading] = useState(false);

  const handelSetFavCar = () => {
    setCarFavLoading(true);
    const body = {
      CarModelId: car?.Id,
      IsAdd: !isFav,
    };
    Api.post("/WishLists/AddOrDeleteFromWishList", body).then(
      (res) => {
        setCarFavLoading(false);
        if (res?.status === 200) {
          //   console.log(res?.data?.metas?.message);
          message?.success(res?.data?.metas?.message);
          setisFav(!isFav);
        }
        // setCarSearch();
      },
      (err) => {
        setCarFavLoading(false);
        // console.log(err, "errrrrrrrrrrrrrrrrrrrrrrrrrrr")
      }
    );
  };

  useEffect(() => {
    setisFav(car?.IsAddedToWishList);
  }, []);

  return (
    <div className="car-card-holder">
      {CarSearchLoading ? (
        <div className="car-img-holder">
          <Skeleton.Image active />
        </div>
      ) : (
        <div className="car-img-holder">
          <img src={car?.Image || CarImg} alt="" />
        </div>
      )}

      <div className="car-content">
        {CarSearchLoading ? (
          <Skeleton.Input active block />
        ) : (
          <h4 className="car-title">{car?.NameLT}</h4>
        )}
        {CarSearchLoading ? null : (
          <span className="car-type">{car?.GearType?.NameLT}</span>
        )}
        {CarSearchLoading ? (
          <Skeleton.Button active />
        ) : (
          <p className="car-price">يبدا من : {car?.Price}</p>
        )}
        {CarSearchLoading ? (
          <Skeleton.Input active block />
        ) : (
          <div className="card-btn-action">
            <Button type="primary" block onClick={() => setDetailsModal(car)}>
              اختر
            </Button>
            <Button
              onClick={handelSetFavCar}
              shape="circle"
              loading={CarFavLoading}
              icon={
                isFav ? (
                  <HeartFilled style={{ color: "#FA2C2C" }} />
                ) : (
                  <HeartOutlined />
                )
              }
            />
          </div>
        )}
      </div>
    </div>
  );
}
